<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row mb-2">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGradingRange.mainProgram')
          }}</label>
          <a-select
            v-model="model.acp_id"
            style="width: 100%"
            :options="main_programs"
            @change="onMainProgramChange"
          ></a-select>
          <div class="validate ts-text-xs" v-if="errors.has('acp_id')">
            {{ errors.first('acp_id') }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <label class="required ts-text-xs"
            >{{ $t('totalScoreGradingRange.programStructure') }}
            {{
              program_structures_label
                ? ' ( ' + program_structures_label + ' ) '
                : ''
            }}
          </label>
          <a-select
            v-model.number="model.program_structure_id"
            style="width: 100%"
            :options="program_structures"
            @change="structureChange"
          ></a-select>
          <div
            class="validate ts-text-xs"
            v-if="errors.has('program_structure_id')"
          >
            {{ errors.first('program_structure_id') }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGradingRange.minScore')
          }}</label>
          <input
            type="number"
            step="any"
            class="form-control"
            v-model.number="model.score_start"
          />
          <div class="validate ts-text-xs" v-if="errors.has('score_start')">
            {{ errors.first('score_start') }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGradingRange.maxScore')
          }}</label>
          <input
            type="number"
            step="any"
            class="form-control"
            v-model.number="model.score_stop"
          />
          <div class="validate ts-text-xs" v-if="errors.has('score_stop')">
            {{ errors.first('score_stop') }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGradingRange.definition')
          }}</label>
          <a-select
            v-model.number="model.grade_definition_id"
            style="width: 100%"
            :options="definitions"
          ></a-select>
          <div
            class="validate ts-text-xs"
            v-if="errors.has('grade_definition_id')"
          >
            {{ errors.first('grade_definition_id') }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('school.academic.setup.program.grade.scoring_version')
          }}</label>
          <a-select
            v-model.number="model.score_version_id"
            style="width: 100%"
            showSearch
            :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase())"
          >
            <a-select-option
              v-for="v in scoring_versions"
              :key="v.id"
              :value="v.id"
            >{{ v.version_name }}</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <ts-checkbox v-model="model.is_percentage">{{
            $t('totalScoreGradingRange.percentage')
          }}</ts-checkbox>
          <ts-checkbox v-model="model.is_pass">{{
            $t('totalScoreGradingRange.pass')
          }}</ts-checkbox>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12 text-right">
          <slot name="action-button"></slot>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'scoreComponentForm',
  props: ['value', 'validate'],
  data () {
    return {
      loading: false,
      errors: new Errors(),
      model: {},
      main_programs: [],
      definitions: [],
      program_structures: [],
      program_structures_label: null,
      scoring_versions: []
    }
  },
  created () {
    this.model = this.value
    this.fetchMainProgram()
    this.fetchScoreVersions()
  },
  methods: {
    ...mapActions('totalScoreGradingRange', [
      'getProgramStructure',
      'getDefinition',
      'getScoreVersions'
    ]),
    fetchScoreVersions () {
      this.getScoreVersions()
        .then(response => {
          this.scoring_versions = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchMainProgram () {
      this.program_structures_label = null
      this.loading = true
      this.$store
        .dispatch('totalScoreGradingRange/getMainProgram')
        .then(response => {
          this.main_programs = response.data.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getProgramStructuresLabel (data) {
      if (data) {
        if (data.is_grade) {
          this.program_structures_label = 'Grade'
        } else if (data.is_level) {
          this.program_structures_label = 'Level'
        } else if (data.is_main_program) {
          this.program_structures_label = 'Main Program'
        } else if (data.is_sub_program) {
          this.program_structures_label = 'Sub Program'
        }
      } else {
        this.program_structures_label = null
      }
    },
    onMainProgramChange (acp_id, clear = true) {
      this.program_structures = []
      this.program_structures_label = null
      this.definitions = []
      if (clear) {
        this.model.program_structure_id = null
        this.model.grade_definition_id = null
      }

      this.loading = true
      this.getProgramStructure(acp_id)
        .then(response => {
          if (this.model.acp_id) {
            this.getProgramStructuresLabel(response.data['0'])
          }
          this.program_structures = response.data.map(el => ({
            value: parseInt(el.program_structure_id),
            label: el.structure_name_en,
            sc_setup_id: el.sc_setup_id,
            acp_id: el.acp_id,
            acps_id: el.acps_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      this.getDefinition({ acp_id: acp_id, acps_id: null })
        .then(response => {
          this.definitions = response.data.map(el => ({
            value: el.grade_definition_id,
            label: el.definition_name_en + '|' + el.grade
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    structureChange (value, option) {
      this.model.sc_setup_id = option.data.props.sc_setup_id
      let acps_id = option.data.props.acps_id
      this.getDefinition({ acp_id: this.model.acp_id, acps_id: acps_id })
        .then(response => {
          this.definitions = response.data.map(el => ({
            value: el.grade_definition_id,
            label: el.definition_name_en + '|' + el.grade
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cleardata () {
      this.program_structures_label = null
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
    'model.sc_grade_range_id': function () {
      this.onMainProgramChange(this.value.acp_id, false)
    }
  }
}
</script>
